(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["faceted-filters"] && !Shopify.designMode) return;
  try {
    /* Locks page scroll while the filter panel is open.

     Reuses the theme's own mechanism (see SideDrawer in main.js): body gets
     `position: fixed` plus a negative `top` holding the scroll position. Plain
     `overflow: hidden` is not enough - Safari on iOS keeps scrolling the page
     anyway. `body body.fixed` in main.css already pads for the vanished
     scrollbar, so nothing shifts on desktop.

     The open state is read off the container's classes rather than tracked on
     click, so it stays correct no matter what closed the panel - the toggle
     button, the shade, the close icon or a class change during ajax filtering. */
  (function () {
    function init() {
      var container = document.querySelector('filter-container');

      if (!container) return;

      var isLocked = false;

      function isPanelOpen() {
        return (
          container.classList.contains('filter-container--show-filters-desktop') &&
          container.classList.contains('filter-container--show-filters-mobile')
        );
      }

      function sync() {
        var shouldLock = isPanelOpen();

        if (shouldLock === isLocked) return;

        isLocked = shouldLock;

        if (shouldLock) {
          document.body.style.top = '-' + window.scrollY + 'px';
          document.body.classList.add('fixed');
          return;
        }

        var scrollY = parseInt(document.body.style.top || '0', 10);

        document.body.style.top = '';
        document.body.classList.remove('fixed');
        window.scrollTo(0, -scrollY);
      }

      new MutationObserver(sync).observe(container, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-mini"] && !Shopify.designMode) return;
  try {
    (function () {
    function loadProductByHandle(handle) {
      return fetch('/products/' + handle + '.js').then(function (response) {
        return response.json();
      });
    }

    function closeSelect(select) {
      if (!select) return;

      select.classList.remove('is-open');

      var toggle = select.querySelector('[data-select-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }

    function closeAllSelects(exceptSelect) {
      document.querySelectorAll('.product-card-mini__select.is-open').forEach(function (el) {
        if (el !== exceptSelect) closeSelect(el);
      });
    }

    function initCard(card) {
      if (card.dataset.cardReady === 'true') return;

      var form = card.querySelector('.product-card-mini__form');
      var jsonScript = card.querySelector('[data-variants]');

      if (!form || !jsonScript) return;

      card.dataset.cardReady = 'true';

      var variants = JSON.parse(jsonScript.textContent);
      var variantIdInput = form.querySelector('.js-variant-id');
      var addToCartBtn = form.querySelector('.product-card-mini__add-to-cart');
      var image = card.querySelector('.product-card-mini__image');
      var imageLink = card.querySelector('.product-card-mini__image-wrap');
      var titleLink = card.querySelector('.product-card-mini__title');

      var colorOptions = Array.prototype.slice.call(card.querySelectorAll('.product-card__color-option'));

      var select = form.querySelector('.product-card-mini__select');
      var toggle = form.querySelector('[data-select-toggle]');
      var panel = form.querySelector('[data-select-panel]');
      var valueEl = form.querySelector('.product-card-mini__select-value');
      var labelEl = form.querySelector('.js-selected-size-label');
      var placeholder = valueEl ? valueEl.dataset.placeholder || '' : '';
      var optionInputs = Array.prototype.slice.call(form.querySelectorAll('.js-option'));
      var hasSizeOptions = optionInputs.length > 0;

      function getSelectedSize() {
        for (var i = 0; i < optionInputs.length; i++) {
          if (optionInputs[i].checked) return optionInputs[i].value;
        }

        return '';
      }

      function setSizeLabel(label) {
        if (labelEl) labelEl.textContent = label || '';

        if (!valueEl) return;

        valueEl.textContent = label || placeholder;
        valueEl.classList.toggle('is-placeholder', !label);
      }

      function updateAddToCartState() {
        if (!addToCartBtn) return;

        var size = getSelectedSize();

        setSizeLabel(size);
        addToCartBtn.disabled = hasSizeOptions && !size;
      }

      function updateVariantId() {
        var selected = [];

        optionInputs.forEach(function (input) {
          if (input.checked) {
            selected.push({ value: input.value, position: Number(input.dataset.optionPosition) });
          }
        });

        var variant = variants.find(function (v) {
          return selected.every(function (option) {
            return v.options[option.position] === option.value;
          });
        });

        if (variant) variantIdInput.value = variant.id;

        updateAddToCartState();
      }

      if (toggle) {
        toggle.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();

          if (select.classList.contains('is-open')) {
            closeSelect(select);
          } else {
            closeAllSelects(select);
            select.classList.add('is-open');
            toggle.setAttribute('aria-expanded', 'true');
          }
        });
      }

      optionInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          updateVariantId();
          closeSelect(select);
        });
      });

      function updateSizeOptions(newProduct) {
        var index = newProduct.options.findIndex(function (option) {
          var name = option.name || option;
          return name.toLowerCase().indexOf('size') !== -1;
        });

        if (index === -1 || !panel) {
          variantIdInput.value = newProduct.variants[0].id;
          return;
        }

        var availability = {};

        newProduct.variants.forEach(function (variant) {
          var value = variant.options[index];

          if (!availability[value]) availability[value] = false;
          if (variant.available) availability[value] = true;
        });

        var firstAvailable = newProduct.variants.find(function (variant) {
          return variant.available;
        });
        var defaultSize = firstAvailable ? firstAvailable.options[index] : '';

        panel.querySelectorAll('label').forEach(function (label) {
          var input = label.querySelector('input');

          if (!input) return;

          var available = availability[input.value] || false;

          input.disabled = !available;
          input.checked = available && input.value === defaultSize;

          label.classList.toggle('product-card-option-active', available);
          label.classList.toggle('product-card-option-disabled', !available);
        });

        variantIdInput.value = firstAvailable ? firstAvailable.id : newProduct.variants[0].id;

        closeSelect(select);
        setSizeLabel(defaultSize);
      }

      function updateCardMedia(newProduct) {
        var url = newProduct.images[0];

        function sized(width) {
          return 'https:' + url.replace(/(\.[^.]+)$/, '_' + width + 'x$1');
        }

        if (image && url) {
          image.classList.add('is-loading-image');
          image.src = sized(600);
          image.srcset = sized(600) + ' 600w, ' + sized(1200) + ' 1200w';
          image.onload = function () {
            image.classList.remove('is-loading-image');
          };
          image.onerror = function () {
            image.classList.remove('is-loading-image');
          };
        }

        if (imageLink) imageLink.setAttribute('href', newProduct.url);
        if (titleLink) {
          titleLink.setAttribute('href', newProduct.url);
          titleLink.textContent = newProduct.title;
        }
      }

      colorOptions.forEach(function (colorOption) {
        colorOption.addEventListener('click', function () {
          colorOptions.forEach(function (el) {
            el.classList.remove('is-active');
          });

          this.classList.add('is-active');

          var handle = this.dataset.productHandle;

          if (!handle) return;

          loadProductByHandle(handle)
            .then(function (newProduct) {
              variants = newProduct.variants;
              form.dataset.productId = newProduct.id;
              card.dataset.productId = newProduct.id;

              updateCardMedia(newProduct);
              updateSizeOptions(newProduct);
            })
            .catch(function (error) {
              console.error('Error loading color variant:', error);
            })
            .then(function () {
              updateAddToCartState();
            });
        });
      });

      form.addEventListener('submit', async function (event) {
        if (hasSizeOptions && !getSelectedSize()) {
          event.preventDefault();
          updateAddToCartState();
          return;
        }

        if (theme.settings.afterAddToCart !== 'drawer') return;

        event.preventDefault();

        if (addToCartBtn.getAttribute('aria-disabled') === 'true') return;

        addToCartBtn.setAttribute('aria-disabled', 'true');
        addToCartBtn.classList.add('is-loading');

        var formData = new FormData(form);
        var sectionsToUpdate = ['page-header', 'cart-drawer']
          .map(function (selector) {
            return document.querySelector(selector);
          })
          .filter(Boolean);

        formData.append('sections_url', window.location.pathname);
        formData.append(
          'sections',
          sectionsToUpdate
            .map(function (el) {
              return el.dataset.sectionId;
            })
            .join(',')
        );

        try {
          var response = await fetch(theme.routes.cartAdd, {
            method: 'POST',
            headers: {
              Accept: 'application/javascript',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
          });
          var data = await response.json();

          if (!response.ok) throw new Error(response.status);

          if (data.sections) {
            sectionsToUpdate.forEach(function (el) {
              el.updateFromCartChange(data.sections[el.dataset.sectionId]);
            });
          }

          document.querySelector('.js-cart-drawer')?.open();

          this.dispatchEvent(
            new CustomEvent('on:cart:add', {
              bubbles: true,
              detail: { variantId: data.variant_id }
            })
          );

          addToCartBtn.classList.add('is-success');
        } catch (error) {
          console.error('Error adding to cart:', error);

          this.dispatchEvent(
            new CustomEvent('on:cart:error', {
              bubbles: true,
              detail: { error: '' }
            })
          );
        } finally {
          addToCartBtn.removeAttribute('aria-disabled');

          setTimeout(function () {
            addToCartBtn.classList.remove('is-loading');
            addToCartBtn.classList.remove('is-success');
          }, 2000);
        }
      });

      updateAddToCartState();
    }

    function init() {
      document.querySelectorAll('.product-card-mini').forEach(initCard);
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAllSelects(null);
    });

    document.addEventListener('click', function (event) {
      var target = event.target;

      if (!target || typeof target.closest !== 'function') return;
      if (!target.closest('.product-card-mini__select')) closeAllSelects(null);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('on:cart-drawer:after-open', init);
    document.addEventListener('on:cart:after-merge', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
